module.exports = __webpack_public_path__ + "static/img/13.8b25c8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/13.png
// module id = kdOF
// module chunks = 0